export const getCustomViewTemplate = (viewName, visibleToRole) => {
  return `
    import React from 'react';

    interface ${viewName}ViewProps {
    eventData: any;
    userData: any;
    pluginData: any;
    }

    export default function ${viewName}View({ eventData, userData, pluginData }: ${viewName}ViewProps) {
        return (
            <div className="p-4 bg-black rounded shadow">
            <h2 className="text-xl font-bold mb-4">Let's Hang ${viewName} View</h2>
            <p>This is a custom view of the plugin. You can integrate it anywhere inside the codebase 
            using Plugin Renderer</p>
            <p>Start customizing this component to build the view.</p>
            </div>
        );
    }`
}
